<template>
  <div>
    <div class="mb-3" v-html="schema.$title" />

    <comment :schema="schema" />
  </div>
</template>

<script>
import Comment from './Comment.vue';

// @vuese
// Formularz potwierdzenia zamknięcia naboru
// @group ActionData
export default {
  components: { Comment },
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
